module.exports = "<div class=pagination-wrapper> <ul class=pagination> <li> <a ng-class=\"{'disabled-page': $ctrl.currentPage<=1}\" ng-click=$ctrl.goToPage($ctrl.currentPage-1)> <i class=\"fa fa-chevron-left\"></i> </a> </li> <li ng-repeat=\"page in $ctrl.pageOptions\"> <a ng-click=$ctrl.goToPage(page) ng-class=\"{'current-page': $ctrl.currentPage==page}\"> {{ page }} </a> </li> <li> <a ng-class=\"{'disabled-page': $ctrl.currentPage>=$ctrl.maxPage}\" ng-click=$ctrl.goToPage($ctrl.currentPage+1)> <i class=\"fa fa-chevron-right\"></i> </a> </li> </ul> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/common/paginator/paginator.html
// module id = 357
// module chunks = 0